'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable no-underscore-dangle */


var _utilUrl = require('./util-url');

var _utilUrl2 = _interopRequireDefault(_utilUrl);

var _device = require('@tencent/device');

var _device2 = _interopRequireDefault(_device);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ext = {
  before: {},
  succ: {},
  err: {}
};

module.exports = ext;

/**
 * bkn
 */
ext.before.bkn = function () {
  var _option = this.option,
      host = _option.host,
      url = _option.url;

  var isQLiveCgi = _utilUrl2.default.checkQLiveCgi(host, url);
  if (isQLiveCgi) {
    return;
  }

  this.option.data = this.option.data || {};
  // eslint-disable-next-line no-useless-escape
  if (_device2.default.is) {
    // 安卓手Q有发现结合版意外地把 ilive_a2 也种入的情况，导致 bkn 校验失败，这里处理一下
    this.option.data.bkn = encryptSkey(getCookie('skey'));
  } else {
    var a2Cookie = getCookie('ilive_a2');
    var shangfenA2Cookie = getCookie('a2');
    var huiyinCookie = getCookie('huiyin_a2');
    if (a2Cookie) {
      this.option.data.bkn = encryptSkey(a2Cookie);
    } else if (shangfenA2Cookie) {
      this.option.data.bkn = encryptSkey(shangfenA2Cookie);
    } else if (huiyinCookie) {
      this.option.data.bkn = encryptSkey(huiyinCookie);
    } else {
      this.option.data.bkn = encryptSkey(getCookie('skey'));
    }
  }
};

function encryptSkey(str) {
  if (!str) {
    return '';
  }
  var hash = 5381;
  for (var i = 0, len = str.length; i < len; ++i) {
    hash += (hash << 5) + str.charAt(i).charCodeAt();
  }
  return hash & 0x7fffffff;
}

function getCookie(n) {
  var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]*)(;|$)'));
  return !m ? '' : decodeURIComponent(m[2]);
}

function uin() {
  var u = getCookie('ilive_uin') || getCookie('uin') || getCookie('p_uin') || getCookie('qlive_p_uin');
  return u && parseInt(u.replace(/\D/g, ''), 10) || null;
}

var _localUsed = {};
/**
 * localStorage 缓存
 */
ext.before.local = function () {
  if (!window.localStorage) {
    return;
  }
  var option = this.option;

  var key = getLocalKey(option);
  var cache = getItem(key);
  if (cache && !_localUsed[key] // 缓存只能用一次
  ) {
      _localUsed[key] = true;
      cache._isLocal = true;
      this.processSucc(cache);
    }

  // inject succ save
  option.succ = (option.succ || []).concat(function (data) {
    // 我们在最后, 所以retCode不需要判断
    if (!data._isLocal) {
      // 保存最原始的responseText
      setItem(key, this.responseText || '', true);
    }
  });
};

ext.before.local.option = {
  localEnable: false // 默认禁用
};

function getLocalKey(option) {
  if (option.localKey) {
    return option.localKey;
  }
  var qs = [];
  var data = option.data || {};
  Object.keys(data).forEach(function (k) {
    if (Object.prototype.hasOwnProperty.call(data, k)) {
      var v = data[k];
      if (isSerializationParam(k, v)) {
        qs.push(k + '=' + v.toString());
      }
    }
  });
  return option.url + (option.url.match(/\?/) ? '' : '?') + qs.sort().join('&');
}

function isSerializationParam(key, value) {
  return !key.match(/^_/) && !key.match(/^(t|bkn)$/) && value !== undefined && value !== null && value.toString().length < 100;
}

/**
 * localStorage.setItem
 */
function setItem(key, data, raw) {
  try {
    localStorage.setItem(key, raw ? data : JSON.stringify(data));
  } catch (ex) {
    // 数据可能遭到了破坏
    localStorage.removeItem(key);
  }
}

/**
 * localStorage.getItem
 */
function getItem(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || 'null');
  } catch (ex) {
    // 数据可能遭到了破坏
    localStorage.removeItem(key);
    return null;
  }
}

/**
 * 增加 query params（即使使用 POST 方法）
 */
ext.before.params = function () {
  var _option2 = this.option,
      type = _option2.type,
      url = _option2.url,
      _option2$data = _option2.data,
      data = _option2$data === undefined ? {} : _option2$data,
      params = _option2.params;

  if (!params || (typeof params === 'undefined' ? 'undefined' : _typeof(params)) !== 'object') {
    return;
  }
  var isPost = typeof type === 'string' && type.toLowerCase() === 'post';
  if (isPost) {
    this.option.url = _utilUrl2.default.addQueryParams(url, params);
  } else {
    this.option.data = _extends({}, data, params);
  }
};

/**
 * qlive cgi 自动附带 gtk (csrf token)
 */
ext.before.gtk = function () {
  var _option3 = this.option,
      host = _option3.host,
      url = _option3.url,
      params = _option3.params;

  var isQLiveCgi = _utilUrl2.default.checkQLiveCgi(host, url);
  if (!isQLiveCgi) {
    return;
  }

  var skey = getCookie('p_skey') || getCookie('qlive_p_skey');
  var csrfToken = encryptSkey(skey);
  this.option.params = params || {};
  this.option.params.g_tk = csrfToken;
};

/**
 * qlive cgi 自动附带 plat_id（平台 ID）
 */
ext.before.platId = function () {
  var _option4 = this.option,
      host = _option4.host,
      url = _option4.url,
      params = _option4.params;

  var isQLiveCgi = _utilUrl2.default.checkQLiveCgi(host, url);
  if (!isQLiveCgi) {
    return;
  }

  var platformId = 0;
  if (_device2.default.isIOS) {
    platformId = 110;
  } else if (_device2.default.isAndroid) {
    platformId = 109;
  }
  this.option.params = params || {};
  this.option.params.plat_id = platformId;
};

/**
 * proxy的请求query带上一个随机数
 * 因为iOS内核问题不能保证相同url的请求返回的时序问题，而cgiProxy的形式请求的url都是完全相同的一个地址，所以需要加一个唯一的query参数保证每次请求的url不一样避免此问题
 * @returns
 */
ext.before.requestId = function () {
  var _option5 = this.option,
      params = _option5.params,
      cgiProxy = _option5.cgiProxy;


  if (!cgiProxy) return;

  this.option.params = params || {};
  this.option.params._ = Math.random();
};

/**
 * 返回码验证
 * @param {Object} data 返回数据
 */
ext.succ.retCode = function (data) {
  var _option6 = this.option,
      getRetCode = _option6.getRetCode,
      cgiProxy = _option6.cgiProxy,
      reqData = _option6.data;

  var isOuterCodeValid = getRetCode(data) === 0;
  if (cgiProxy) {
    var methodKeys = Object.keys(reqData);
    return methodKeys.length === 1 ? isOuterCodeValid && data.result && _typeof(data.result) === 'object' && getRetCode(data.result[methodKeys[0]]) === 0 : isOuterCodeValid;
  }
  return isOuterCodeValid;
};

/**
 * 网络验证
 * @param {Object} data 返回数据
 */
ext.succ.networkError = function (data) {
  return data.networkError !== true;
};

var retCodePool = []; // 批量上报池

/**
 * 返回码上报
 * @param {Object} data 返回数据
 */
ext.succ.retCodeReport = function (data) {
  var retCode = this.option.getRetCode(data);
  var match = this.option.url.match(/^(https?:)?\/\/([^/]+)([^?]*)?/);
  var domain = match ? match[2] : location.hostname;
  var cgi = match ? match[3] || '/' : this.option.url;
  retCodePool.push({
    domain: domain,
    cgi: cgi,
    type: retCode === 0 ? 1 : 2, // 成功失败
    code: retCode,
    time: +new Date() - this.sendAt, // 延时 整形，必选，单位ms
    rate: 1 // 采样率（100 意为 1/100的采样）
  });
  setTimeout(doRetCodeReport, 1000);
};

function doRetCodeReport() {
  var fields = ['domain', 'cgi', 'type', 'code', 'time', 'rate'];
  if (retCodePool.length) {
    var items = retCodePool.splice(0, 10); // 最多上报10个

    var platform = 'unknown';

    if (_device2.default.isIOS) {
      platform = 'ios';
    } else if (_device2.default.isAndroid) {
      platform = 'android';
    }

    var param = {
      uin: uin() || '', // QQ号 长整形，可选
      key: fields.join(','),
      appid: 20149,
      platform: platform,
      apn: _device2.default.netType ? _device2.default.netType.toLowerCase() : 'unknown'
    };
    Object.keys(items).forEach(function (i) {
      var item = items[i];
      Object.keys(fields).forEach(function (j) {
        var k = fields[j];
        param[+i + 1 + '_' + (+j + 1)] = typeof item[k] !== 'undefined' ? item[k] : '';
      });
    });

    retCodePool.length && setTimeout(doRetCodeReport, 100);
  }
}